module.exports = __webpack_public_path__ + "static/meeting-f00fab98a7e499ffce2f81e798f4c5bc.png";